import { sendToFlutter } from '@/helpers/flutter'
import type { App } from 'vue'

export default {
  install: (app: App): void => {
    app.config.globalProperties.$sendToFlutter = sendToFlutter
  },
}
